module.exports = __webpack_public_path__ + "static/media/working-light.388e70f8.svg";